// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format11 } from '../../constants';

/** Jersey */
const JE: PhoneNumberData = [
  44,
  'JE',
  10,
  format11,
  /^(?:7(?:(?:(?:50|82)9|937)|7(?:00[378]|97)))/,
];

export default JE;
